import {Container, Grid, Paper, TableBody, TableHead, TextField} from "@mui/material";
import {
    StyledButtonContainer, StyledButtonOrange,
    StyledTable, StyledTableBodyRow,
    StyledTableCell, StyledTableCellHeader, StyledTableContainer,
    StyledTableHeadRow
} from "../../styles/MyStyles";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import * as DataProvider from "../../logic/DataProvider";
import {GetEnumMenuItems, GetEnumValueName} from "../../logic/EnumHelper";
import dayjs from "dayjs";
import {SortTickets} from "../../logic/TicketHelper";
import moment from "moment";
import * as MyStyles from "../../styles/MyStyles";


const ClientTicketsPage = () => {
    const navigate = useNavigate();
    const [tickets, setTickets] = useState([]);

    const [searchQuery, setSearchQuery] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');

    useEffect(() => {
        fetchTickets();
    }, []);

    const fetchTickets = () => {
        try {
            let bundle = DataProvider.GetClientBundle();
            if (bundle.tickets) {
                let entities = bundle.tickets;

                SortTickets(entities);
                setTickets(JSON.parse(JSON.stringify(entities)));
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const onTicketClick = (id) => {
        navigate(`${id}`);
    };

    const handleRequestNew = (event) => {
        navigate(`new`);
    };

    const handleSearchQueryChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const filteredTickets = tickets ? tickets.filter(
        (ticket) =>
            ticket.title.toLowerCase().includes(searchQuery.toLowerCase()) &&
            (selectedType === '' || ticket.type === parseInt(selectedType)) &&
            (selectedStatus === '' || ticket.status === parseInt(selectedStatus))
    ) : [];

    const handleTypeFilter = (event) => {
        setSelectedType(event.target.value);
    };
    const handleStatusFilter = (event) => {
        setSelectedStatus(event.target.value);
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <TextField
                        label="Search"
                        value={searchQuery}
                        onChange={handleSearchQueryChange}
                        margin="normal"
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        select
                        label="Type"
                        value={selectedType}
                        onChange={handleTypeFilter}
                        margin="normal"
                        size="small"
                        fullWidth
                    >
                        {GetEnumMenuItems('ticketType', true)}
                    </TextField>
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        select
                        label="Status"
                        value={selectedStatus}
                        onChange={handleStatusFilter}
                        margin="normal"
                        size="small"
                        fullWidth
                    >
                        {GetEnumMenuItems('ticketStatus', true)}
                    </TextField>
                </Grid>
            </Grid>
            <StyledButtonContainer container>
                <Grid>
                    <StyledButtonOrange variant="contained" onClick={handleRequestNew}>
                        New
                    </StyledButtonOrange>
                </Grid>
            </StyledButtonContainer>
            <StyledTableContainer component={Paper}>
                <StyledTable>
                    <TableHead>
                        <StyledTableHeadRow>
                            <StyledTableCellHeader columncount={5}>Last Activity</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={5}>Open Date</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={5}>Title</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={5}>Type</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={5}>Status</StyledTableCellHeader>
                        </StyledTableHeadRow>
                    </TableHead>
                    <TableBody>
                        {filteredTickets && filteredTickets.map((ticket) => (
                            <StyledTableBodyRow key={ticket.id} onClick={() => onTicketClick(ticket.id)}>
                                <StyledTableCell>{moment(ticket.lastActivityDate).fromNow()}</StyledTableCell>
                                <StyledTableCell>{dayjs(ticket.openDate).format(MyStyles.DateFormat)}</StyledTableCell>
                                <StyledTableCell>{ticket.title}</StyledTableCell>
                                <StyledTableCell>{GetEnumValueName('ticketType', ticket.type)}</StyledTableCell>
                                <StyledTableCell>{GetEnumValueName('ticketStatus', ticket.status)}</StyledTableCell>
                            </StyledTableBodyRow>
                        ))}
                    </TableBody>
                </StyledTable>
            </StyledTableContainer>
        </Container>
    );
};
export default ClientTicketsPage;